<body>
  <router-outlet></router-outlet>
  <ng-http-loader [backgroundColor]="'#0d6efd'"></ng-http-loader>
</body>
